<template>
  <div class="feedbackDialog" v-if="show">
    <div class="dialog">
      <div class="dialog-header">
        <div class="dialog-close-btn" @click="closeDialog">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M11.7277 10.3137L16.6774 15.2635L15.4752 16.4657L10.5255 11.5159L5.36373 16.6777L4.16151 15.4754L9.32325 10.3137L4.16151 5.15197L5.36373 3.94975L10.5255 9.11149L15.4752 4.16174L16.6774 5.36396L11.7277 10.3137Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </div>
        <p class="title_row">报告页面问题</p>
        <p class="title_row">管理员会尽快复核您的反馈</p>
      </div>
      <div class="dialog-body">
        <el-radio-group v-model="feedbackType">
          <el-radio :label="1">内容不准确,有错误</el-radio>
          <el-radio :label="2">链接失效,未找到对应内容</el-radio>
          <el-radio :label="3">其他问题</el-radio>
        </el-radio-group>
        <el-input
          v-model="feedbackContent"
          :maxlength="300"
          :rows="6"
          :resize="'none'"
          type="textarea"
          placeholder="请具体描述问题现象"
        />
        <div class="tips" v-if="feedbackContent.length < 10">
          至少输入10个字符
        </div>
        <div class="tips" v-else>
          还可以输入<span class="highlight">{{
            300 - feedbackContent.length
          }}</span
          >个字符
        </div>
      </div>
      <div class="dialog-footer">
        <div
          class="dialog-btn confirm"
          :class="{ canComfirm: feedbackType && feedbackContent.length >= 10 }"
          @click="confirmClick"
        >
          提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { feedbackCreate } from "../services/api/index";
export default {
  name: "feedbackDialog",
  data() {
    return {
      show: false,
      feedbackType: 0,
      feedbackContent: "",
    };
  },
  mounted() {},
  methods: {
    closeDialog() {
      console.log("closeDialog - ");
      this.feedbackType = 0;
      this.feedbackContent = "";
      this.changeDialog(false);
    },
    changeDialog(flag) {
      this.show = flag;
    },
    confirmClick() {
      console.log(
        "confirmClick - ",
        this.feedbackType,
        this.feedbackContent.length
      );
      if (
        !this.feedbackType ||
        this.feedbackContent.length < 10 ||
        this.feedbackContent.length > 300
      )
        return;
      console.log("confirmClick - 2");
      feedbackCreate({
        feedbackType: this.feedbackType,
        feedbackContent: this.feedbackContent,
        questionType: 2,
        invalidLink: window.location.href
      })
        .then((res) => {
          console.log("feedback res - ", res);
          if (res[0]) {
            Message.error(res[0].Message || "请稍后重试");
            return;
          }
          const data = res[1];
          if (data.Code == 0) {
            Message.success(data.Message);
          } else if (res.Code === -5002) {
            Message.error('请稍等重试');
          } else {
            Message.error(data.Message);
          }
        })
        .catch((err) => {
          console.log("feedback err - ", err);
          Message.error(err.Message || "请稍后重试");
        });
      this.closeDialog();
    },
  },
};
</script>

<style lang='scss' scoped>
.feedbackDialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 424px;
    height: 500px;
    padding: 40px 32px 32px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .dialog-header {
      width: 100%;
      line-height: 30px;
      color: #26292d;
      font-size: 20px;
      text-align: center;
      font-weight: 600;
      .dialog-close-btn {
        position: absolute;
        top: 16px;
        right: 20px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .dialog-body {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.9);
      /deep/ .el-radio-group {
        .el-radio {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          color: #26292d;
          &.is-checked {
            .el-radio__inner {
              border-color: #42878c;
              background-color: #fff;
              &::after {
                width: 7px;
                height: 7px;
                background-color: #42878c;
              }
            }
            .el-radio__label {
              color: #26292d;
            }
          }
        }
      }
      /deep/ .el-textarea {
        width: 100%;
        height: 136px;
        .textarea__inner {
          border-radius: 0;
        }
        // Webkit 浏览器滚动条样式（Chrome, Safari, Edge）
        .el-textarea__inner {
          // 滚动条整体样式
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }

          // 滚动条轨道
          &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }

          // 滚动条滑块
          &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;

            &:hover {
              background: #a8a8a8;
            }

            &:active {
              background: #8f8f8f;
            }
          }

          // 滚动条按钮（可选）
          &::-webkit-scrollbar-button {
            display: none;
          }

          // Firefox 滚动条样式
          scrollbar-width: thin;
          scrollbar-color: #c1c1c1 #f1f1f1;
        }
      }
      .tips {
        color: #878b8f;
        font-size: 12px;
        line-height: 22px; /* 183.333% */
        padding-top: 4px;
        .highlight {
          color: #2c797f;
        }
      }
    }
    .dialog-footer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .dialog-btn {
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        &.confirm {
          color: rgba(255, 255, 255, 0.9);
          background: linear-gradient(
            79deg,
            rgba(44, 121, 127, 0.3) -15.06%,
            rgba(45, 169, 178, 0.3) 113.88%
          );
          &.canComfirm {
            background: linear-gradient(
              79deg,
              #2c797f -15.06%,
              #2da9b2 113.88%
            );
          }
        }
      }
    }
  }
}
</style>